<template>
  <div class="card_search">
    <div
      v-if="isTopType"
      class="wrap_thumb"
    >
      <img
        :src="generateWebpImage(props.cardData.thumbnail, 'C400x400')"
        alt=""
      />
    </div>
    <div class="wrap_text">
      <div
        v-if="isTopType"
        class="area_tags"
      >
        <span
          v-if="contentType"
          class="item_cate"
          >{{ contentType }}</span
        >
        <span
          v-for="(item, idx) in props.cardData.tag"
          :key="`${idx}_tag`"
          class="item_tag"
          v-html="makeTagHighlight(`#${totalSearchKeyword.searchWord}`, `#${item}`)"
        ></span>
      </div>
      <div
        v-else
        class="area_cate"
      >
        <span
          v-if="props.cardData.category"
          class="item_cate"
          >{{ categoryType }}</span
        >
        <span
          v-if="props.cardData.type && props.cardData.category === 'NEWS'"
          class="item_cate"
          >{{ contentType }}</span
        >
        <span
          v-if="props.cardData.type && props.cardData.category === 'PARTNER'"
          class="item_cate"
          >{{ contentType }}</span
        >
      </div>

      <strong
        class="tit_card"
        v-html="
          type === 'bottom'
            ? makeHighlight(totalSearchKeyword.searchWord, props.cardData.title)
            : props.cardData.title
        "
      ></strong>
      <p
        v-if="props.cardData.content"
        class="desc_card"
        v-html="
          type === 'bottom'
            ? makeHighlight(totalSearchKeyword.searchWord, props.cardData.content)
            : props.cardData.content
        "
      ></p>
      <button
        v-if="collectType"
        class="link_card"
        @click="
          downloadOpen.openDownloadLayer(
            props.cardData.title,
            props.cardData.linkUrl,
            props.cardData.type,
            props.cardData.serviceName,
          )
        "
      >
        자세히 보기
      </button>
      <LinkBasic
        v-else
        :text="'자세히 보기'"
        :link="linkCard"
        :isBlank="props.cardData.category === 'INFORMATION' ? true : false"
        class="link_card"
      />
    </div>
  </div>
</template>
<script setup>
import { useTotalSearchKeyword, useDownloadOpen } from '/stores/store';
const totalSearchKeyword = useTotalSearchKeyword();
const downloadOpen = useDownloadOpen();
const props = defineProps({
  cardData: {
    type: Object,
    default() {
      return {};
    },
  },
  type: {
    type: String,
    default: '',
  },
  contentType: {
    type: String,
    default: '',
  },
});

const isTopType = computed(() => {
  return props.type === 'top' ? true : false;
});

const categoryType = computed(() => {
  switch (props.cardData.category) {
    case 'SERVICE':
      return '서비스';
    case 'PARTNER':
      return '고객사례';
    case 'INFORMATION':
      return '자료실';
    case 'NEWS':
      return '뉴스';
    default:
      return '';
  }
});

const contentType = computed(() => {
  switch (props.cardData.type) {
    case 'REPORT':
      return '언론보도';
      break;
    case 'INSIGHT':
      return '인사이트';
      break;
    case 'NOTICE':
      return '알립니다';
      break;
    default:
      return props.cardData.type;
      break;
  }
});

const linkCard = computed(() => {
  if (props.contentType !== 'etc') {
    switch (props.contentType) {
      case 'case':
        return `/case/${props.cardData.id}`;
      case 'news':
        return `/news/${props.cardData.id}`;
      default:
        return `/service/${props.cardData.linkUrl}`;
    }
  } else {
    switch (props.cardData.category) {
      case 'PARTNER':
        return `/case/${props.cardData.id}`;
      case 'NEWS':
        return `/news/${props.cardData.id}`;
      case 'SERVICE':
        return `/service/${props.cardData.linkUrl}`;
      default:
        return props.cardData.linkUrl;
    }
  }
});

const collectType = computed(() => {
  return props.cardData.collect;
});
</script>
<style lang="scss" scoped>
.card_search {
  display: flex;
  align-items: center;
}
.wrap_thumb {
  flex-shrink: 0;
  width: 200px;
  margin: 0 40px 0 0;
  img {
    width: 100%;
  }
}
.wrap_text {
  width: 100%;
  .area_tags {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    width: 100%;
    -webkit-line-clamp: 1;
    margin: 0 0 0 -8px;
    word-break: break-all;
    .item_cate,
    .item_tag {
      overflow: hidden;
      display: inline-block;
      vertical-align: top;
      font-size: 16px;
      margin: 0 0 8px 8px;
    }
  }

  .area_cate {
    margin-bottom: 8px;
    font-size: 16px;
    span + span {
      &:before {
        content: '∙';
        display: inline-block;
        vertical-align: top;
        margin: 0 4px;
      }
    }
  }
  .tit_card {
    display: block;
    font-size: 20px;
    letter-spacing: -0.5px;
    word-break: break-all;
  }
  .desc_card {
    overflow: hidden;
    font-size: 16px;
    margin: 8px 0 0;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  .link_card {
    display: inline-block;
    vertical-align: top;
    margin-top: 16px;
    padding-right: 28px;
    font-size: 15px;
    letter-spacing: -0.5px;
    color: #666;
    text-decoration: underline;
    @include backgroundImage(
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.146 16.707a.5.5 0 1 0 .708.707l4.95-4.95a.5.5 0 0 0 .14-.434.5.5 0 0 0-.14-.434l-4.95-4.95a.5.5 0 1 0-.708.707l4.677 4.677-4.677 4.677z' fill='%234C4C4C'/%3E%3C/svg%3E",
      24px 24px,
      top right
    );
  }
}

@media screen and (max-width: 811px) {
  .card_search {
    flex-direction: column;
    align-items: flex-start;
  }
  .wrap_thumb {
    width: 100%;
    margin: 0 24px 0 0;
    img {
      width: 100%;
    }
  }
  .wrap_text {
    .area_tags {
      margin-top: 24px;
      .item_cate,
      .item_tag {
        font-size: 14px;
        word-break: break-all;
      }
    }
    .tit_card {
      font-size: 18px;
    }
    .desc_card {
      font-size: 14px;
      -webkit-line-clamp: 3;
    }
    .link_card {
      padding-right: 20px;
      font-size: 14px;
      @include backgroundImage(
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.146 16.707a.5.5 0 1 0 .708.707l4.95-4.95a.5.5 0 0 0 .14-.434.5.5 0 0 0-.14-.434l-4.95-4.95a.5.5 0 1 0-.708.707l4.677 4.677-4.677 4.677z' fill='%234C4C4C'/%3E%3C/svg%3E",
        16px 16px,
        top 2.5px right
      );
    }
  }
}
</style>
